export default {
  type: 'people',
  name: 'Person',
  newButtonLabel: 'Create External Contact',
  permissions: {
    view: { app: 'base_role', role: 'postgraphile_infrastructure' },
    insert: { app: 'people', role: 'people' },
    update: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allPeople',
    orderBy: {
      type: 'PeopleOrderBy',
      default: 'FULL_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        placeholder: 'Name / Address / Email / Affiliation / Etc.',
        searchOnly: true
      },
      {
        name: 'personId',
        searchable: false,
        order: 'PERSON_ID'
      },
      {
        name: 'fullName',
        label: 'Name',
        searchable: false,
        order: 'FULL_NAME'
      },
      {
        name: 'email',
        searchable: false,
        order: 'EMAIL'
      },
      {
        name: 'affiliation',
        searchable: false,
        order: 'AFFILIATION'
      },
      {
        name: 'creationTime',
        label: 'Registration Date',
        searchType: 'form',
        searchOnly: true,
        type: 'daterange'
      },
      [
        {
          name: 'statusCode',
          label: 'Status',
          searchType: 'form',
          type: 'select',
          order: 'STATUS_CODE',
          options: {
            lookup: 'allUserStatuses',
            value: 'statusCode',
            text: 'statusDesc',
            allowNull: true,
            nullText: 'All'
          },
          width: 5
        },
        {
          name: 'scienceUser',
          type: 'select',
          searchType: 'form',
          width: 2,
          fieldType: 'Boolean',
          order: 'SCIENCE_USER',
          options: [
            { value: null, text: 'Both' },
            { value: true, text: 'Yes' },
            { value: false, text: 'No' }
          ]
        },
        {
          name: 'staffInfo',
          label: 'Infrastructure Area',
          type: 'select',
          filterType: 'containsKey',
          searchType: 'form',
          showResults: false,
          width: 5,
          showIf: {
            field: 'statusCode',
            value: 'F'
          },
          options: [
            { value: null, text: 'All' },
            { value: 'tdo', text: 'Technical Coordination' },
            { value: 'eng', text: 'Engineering' },
            { value: 'ops', text: 'Operations' },
            { value: 'wdcomms', text: 'Web Development /  Communications' },
            { value: 'it', text: 'Instrument Mentor' },
            { value: 'dc', text: 'Data Center / ARM Developers' },
            { value: 'sds', text: 'SDS / ADC Admins' },
            { value: 'dqo', text: 'Data Quality Office' },
            { value: 'vap', text: 'VAP Developers' },
            { value: 'so', text: 'Site Operations' },
            { value: 'support', text: 'Misc. Support' },
            { value: 'other', text: 'Other' }
          ]
        }
      ],
      {
        name: 'countryCode',
        label: 'Country',
        searchOnly: true,
        searchType: 'form',
        type: 'select',
        options: {
          lookup: 'allCountries',
          value: 'countryCode',
          text: 'countryName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'CountriesOrderBy',
              default: 'COUNTRY_NAME_ASC'
            }
          ]
        }
      }
    ]
  },
  save: {
    fields: [
      { field: 'personId', type: 'Int', required: true },
      { field: 'nameFirst', required: true },
      'nameMid',
      { field: 'nameLast', required: true },
      'nameSuf',
      { field: 'email', required: true },
      'phone',
      'affiliation',
      {
        field: 'isSmallBusiness',
        type: 'Boolean',
        required: true,
        default: false
      },
      'address1',
      'address2',
      'city',
      'state',
      'zipCode',
      'countryCode',
      'accessStatement',
      'employmentTypeCode',
      'userTypeCode',
      'orcid',
      { field: 'scienceUser', type: 'Boolean', required: true, default: false },
      'approvalComment',
      'comments',
      { field: 'statusCode', required: true, default: 'X' },
      {
        field: 'internalUser',
        type: 'Boolean',
        required: true,
        default: false
      },
      'citizenCountryCode',
      { field: 'username', required: true },
      'archUserId',
      { field: 'staffInfo', type: 'JSON' },
      'rorId',
      { field: 'ldapUidNumber', type: 'Int', required: true, default: 1 }
    ],
    key: ['personId'],
    input: 'person',
    jsonField: 'staffInfo',
    create: 'createPerson',
    update: 'updatePerson'
  },
  load: {
    nodeId: 'person',
    key: 'personByPersonId'
  },
  // creating is an external contact, editing is all people
  form: {
    tabs: true,
    audit: {
      lookup: 'allPersonAudits',
      orderBy: { type: 'PersonAuditsOrderBy', value: 'EVENT_TIME_ASC' },
      dbTableHeaders: [
        { value: 'group_people', header: 'Group:', headerField: 'groupName' },
        { value: 'role_people', header: 'Role:', headerField: 'roleName' },
        {
          value: 'subscriber_table',
          header: 'Email List:',
          headerField: 'nameList'
        },
        {
          value: 'admin_table',
          header: 'Email List Moderator:',
          headerField: 'nameList'
        },
        {
          value: 'application_people',
          header: 'Application:',
          headerField: 'applicationName'
        }
      ],
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    print: {
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    createHeader: 'Create External Contact',
    editHeader: 'Edit Person ${personId} - ${nameFirst} ${nameLast}',
    printHeader: 'Person ${personId} - ${nameFirst} ${nameLast}',
    schema: [
      [
        {
          name: 'nameFirst',
          label: 'Name',
          required: true,
          labelWidth: 4,
          width: 4,
          placeholder: 'First *'
        },
        {
          name: 'nameMid',
          placeholder: 'Middle',
          noLabel: true,
          width: 2
        },
        {
          name: 'nameLast',
          placeholder: 'Last *',
          required: true,
          noLabel: true,
          width: 4
        },
        {
          name: 'nameSuf',
          placeholder: 'Suffix',
          noLabel: true,
          width: 2
        }
      ],
      [
        {
          name: 'email',
          labelWidth: 2,
          type: 'email',
          required: true,
          width: 6
        },
        {
          name: 'phone',
          labelWidth: 2,
          width: 6
        }
      ],
      [
        {
          name: 'rorId',
          type: 'link',
          labelWidth: 6,
          width: 5,
          label: 'ror.org Affiliation Id',
          search: {
            field: 'rorId',
            lookup: 'allRors',
            additionalFields: [
              {
                name: 'rorName',
                type: 'hidden',
                copyTo: 'affiliation'
              }
            ]
          }
        },
        {
          name: 'affiliationName',
          vModel: 'affiliation',
          label: 'Affiliation',
          readonly: true,
          width: 7,
          labelWidth: 2,
          type: 'text',
          hideIf: {
            field: 'rorId',
            value: null
          }
        }
      ],
      [
        {
          name: 'affiliation',
          width: 9,
          labelWidth: 2,
          type: 'link',
          showIf: {
            field: 'rorId',
            value: null
          },
          search: {
            field: 'instName',
            lookup: 'allInstitutions',
            additionalFields: [
              {
                name: 'address1',
                type: 'hidden',
                copyTo: 'address1'
              },
              {
                name: 'address2',
                type: 'hidden',
                copyTo: 'address2'
              },
              {
                name: 'city',
                type: 'hidden',
                copyTo: 'city'
              },
              {
                name: 'state',
                type: 'hidden',
                copyTo: 'state'
              },
              {
                name: 'zipCode',
                type: 'hidden',
                copyTo: 'zipCode'
              },
              {
                name: 'countryCode',
                type: 'hidden',
                copyTo: 'countryCode'
              },
              {
                name: 'smallBusiness',
                type: 'hidden',
                copyTo: 'isSmallBusiness'
              }
            ]
          }
        },
        {
          name: 'isSmallBusiness',
          label: 'Small Business',
          type: 'checkbox',
          width: 3,
          labelWidth: 9
        }
      ],
      [
        {
          name: 'address1',
          label: 'Address 1',
          labelWidth: 4,
          width: 6
        },
        {
          name: 'address2',
          label: 'Address 2',
          labelWidth: 4,
          width: 6
        }
      ],
      [
        {
          name: 'city',
          labelWidth: 2,
          width: 6
        },
        {
          name: 'state',
          labelWidth: 6,
          width: 3
        },
        {
          name: 'zipCode',
          label: 'Zip',
          labelWidth: 2,
          width: 3
        }
      ],
      {
        name: 'countryCode',
        label: 'Country',
        labelWidth: 1,
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allCountries',
          value: 'countryCode',
          text: 'countryName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'CountriesOrderBy',
              default: 'COUNTRY_NAME_ASC'
            }
          ]
        }
      },
      {
        name: 'accessStatement',
        labelWidth: 2,
        hideIf: {
          field: 'personId',
          value: null
        },
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      [
        {
          name: 'employmentTypeCode',
          label: 'Employment Type',
          type: 'select',
          width: 6,
          labelWidth: 4,
          options: {
            allowNull: true,
            lookup: 'allEmploymentTypes',
            value: 'employmentTypeCode',
            text: 'employmentTypeDesc'
          },
          hideIf: {
            field: 'personId',
            value: null
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          name: 'userTypeCode',
          label: 'User Type',
          type: 'select',
          width: 6,
          labelWidth: 4,
          options: {
            lookup: 'allUserTypes',
            value: 'userTypeCode',
            text: 'userTypeDesc'
          },
          hideIf: {
            field: 'personId',
            value: null
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        }
      ],
      [
        {
          name: 'orcid',
          label: 'ORCID',
          width: 6,
          labelWidth: 4,
          hideIf: {
            field: 'personId',
            value: null
          }
        },
        {
          name: 'scienceUser',
          type: 'checkbox',
          width: 6,
          labelWidth: 4,
          hideIf: {
            field: 'personId',
            value: null
          }
        }
      ],
      {
        name: 'approvalComment',
        label: 'Internal Comments',
        labelWidth: 2,
        type: 'textarea',
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      {
        name: 'comments',
        label: 'User Comments',
        labelWidth: 2,
        type: 'textarea',
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      [
        {
          name: 'statusCode',
          label: 'User Status',
          width: 6,
          labelWidth: 4,
          type: 'select',
          default: 'X',
          options: {
            lookup: 'allUserStatuses',
            value: 'statusCode',
            text: 'statusDesc',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'UserStatusesOrderBy',
                default: 'STATUS_DESC_ASC'
              }
            ]
          },
          hideIf: {
            field: 'personId',
            value: null
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          name: 'internalUser',
          label: 'Exclude From Metrics',
          type: 'checkbox',
          width: 6,
          labelWidth: 5,
          hideIf: {
            field: 'personId',
            value: null
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        }
      ],
      [
        {
          name: 'username',
          default: 'dateNow',
          width: 6,
          labelWidth: 4,
          //readonly: true,
          hideIf: {
            field: 'personId',
            value: null
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          name: 'archUserId',
          width: 6,
          labelWidth: 4,
          readonly: true,
          hideIf: {
            field: 'personId',
            value: null
          }
        }
      ],
      {
        type: 'group',
        headerButton: false,
        label: 'Staff Infrastructure Area',
        showIf: { field: 'statusCode', value: 'F' },
        fields: [
          [
            {
              name: 'tdo',
              label: 'Technical Coordination',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'eng',
              label: 'Engineering',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'ops',
              label: 'Operations',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'wdcomms',
              label: 'Web Development /  Communications',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'it',
              label: 'Instrument Mentor',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'dc',
              label: 'Data Center / ARM Developers',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'sds',
              label: 'SDS / ADC Admins',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'dqo',
              label: 'Data Quality Office',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'vap',
              label: 'VAP Developers',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'so',
              label: 'Site Operations',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'support',
              label: 'Misc. Support',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          {
            name: 'other',
            labelWidth: 1
          },
          {
            type: 'group',
            label: 'Observatory / Operations Area',
            showIf: {
              field: 'so',
              value: true
            },
            fields: [
              [
                {
                  name: 'ena',
                  label: 'Eastern North Atlantic',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'nsa',
                  label: 'North Slope of Alaska',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'sgp',
                  label: 'Southern Great Plains',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ],
              [
                {
                  name: 'amf1',
                  label: 'ARM Mobile Facility 1',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'amf2',
                  label: 'ARM Mobile Facility 2',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'amf3',
                  label: 'ARM Mobile Facility 3',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ],
              [
                {
                  name: 'aaf',
                  label: 'ARM Aerial Facility',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'tbs',
                  label: 'Tethered Balloon System (TBS)',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ]
            ]
          }
        ]
      }
    ]
  },
  joinTables: [
    {
      label: 'Projects',
      addLabel: 'Add Project',
      addType: 'form',
      lookup: 'allUserProjects',
      removeLabel: 'Delete the ${projectTitle} project?',
      fields: [
        { name: 'projectTitle', required: true },
        { name: 'estStartDate', alias: 'startDate' },
        { name: 'estEndDate', alias: 'endDate' }
      ],
      addForm: [
        { name: 'projectTitle', required: true },
        {
          name: 'projectTypeCode',
          label: 'Project Type',
          required: true,
          type: 'select',
          options: {
            lookup: 'allProjectTypes',
            value: 'projectTypeCode',
            text: 'projectTypeDesc'
          }
        },
        {
          name: 'primaryProject',
          type: 'checkbox',
          default: false
        },
        { name: 'estStartDate', type: 'date', label: 'Estimated Start Date' },
        { name: 'estEndDate', type: 'date', label: 'Estimated End Date' },
        { name: 'researchStatement', type: 'textarea' },
        { name: 'fundingSource' }
      ],
      create: 'createUserProject',
      update: 'updateUserProject',
      delete: 'deleteUserProject',
      input: 'userProject',
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    {
      label: 'Instrument Contacts',
      addLabel: 'Open Metadata Service',
      addType: 'link',
      addLink: 'https://adc.arm.gov/MetadataService/#/',
      lookup: 'allInstrContacts',
      fields: [
        'instrumentClassCode',
        {
          alias: 'contactType',
          join: 'instrContactsTypeByContactType',
          fields: ['typeDescription']
        },
        { name: 'primaryContact', type: 'Boolean' },
        { name: 'startDate', type: 'timestamp' },
        { name: 'endDate', type: 'timestamp' }
      ],
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    {
      label: 'Roles',
      removeLabel: 'Remove this user from ${roleByRoleName.recordId}?',
      lookup: 'allRolePeople',
      join: 'roleByRoleName',
      fields: [
        {
          field: 'roleName',
          name: 'roleName',
          required: true
        },
        'roleTitle',
        {
          field: 'roleName',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'roles'
        }
      },
      options: [
        {
          field: 'acting'
        }
      ],
      create: 'createRolePerson',
      delete: 'deleteRolePerson',
      input: 'rolePerson',
      formType: 'roles',
      multiHeader: 'Added this user to ${roleName}',
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    {
      label: 'Groups',
      removeLabel: 'Remove this user from ${groupByGroupId.groupName}?',
      lookup: 'allGroupMembers',
      fields: [
        {
          field: 'groupId',
          alias: 'recordId',
          show: false
        },
        {
          field: 'recordFrom',
          show: false
        },
        {
          field: 'groupId',
          type: 'Int',
          required: true,
          show: false
        },
        'groupName',
        'groupDescription'
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'groups'
        }
      },
      create: 'createGroupPerson',
      delete: 'deleteGroupPerson',
      input: 'groupPerson',
      formType: 'groups',
      multiHeader: 'Added this user to ${groupName}',
      permissions: {
        view: { app: 'people', role: 'people' }
      },
      removeIf: {
        field: 'recordFrom',
        value: 'group_people'
      }
    },
    {
      label: 'Email Lists',
      removeLabel: 'Remove this user from ${emailList}?',
      lookup: 'allSubscriberPeople',
      fields: [
        {
          field: 'listSubscriber',
          alias: 'emailList',
          variable: 'emailList',
          required: true
        },
        { field: 'moderationStatus', alias: 'type' },
        { field: 'topicsList', alias: 'description' },
        { field: 'listSubscriber', alias: 'recordId', show: false }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'emails'
        }
      },
      create: 'insertSubscriberPerson',
      delete: 'deleteSubscriberNodeId',
      input: 'subscriberPerson',
      nodeIdType: 'String',
      formType: 'emails',
      multiHeader: 'Added this user to ${emailList}',
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    }
  ]
}
